import * as React from 'react';
import { Page } from '../../components/Page';
import { TitleContainer } from '../TitleContainer';
import { BreadcrumbsContainer } from '../BreadcrumbsContainer';
import { CounterContainer } from '../CounterContainer';
import { BuildersBanner } from '../../components/BuildersBanner';
import { Responsive } from '@cian/ui-kit';
import { ProjectsListContainer } from '../ProjectsListContainer';
import { ActionButtonsContainer } from '../ActionButtonsContainer';
import { MobileFiltersButtonContainer } from '../MobileFiltersButtonContainer';
import { useUxfbUserSessionsUpdater } from '../../hooks';
import { SeoMarkedListContainer } from '../SeoMarkedListContainer';

export const PageContainerMobile: React.FC = () => {
  useUxfbUserSessionsUpdater();

  return (
    <>
      <MobileFiltersButtonContainer />
      <Page>
        <Responsive tablet>
          <BreadcrumbsContainer />
        </Responsive>
        <TitleContainer />
        <CounterContainer />
        <BuildersBanner />
        <ProjectsListContainer />
        <ActionButtonsContainer />
        <SeoMarkedListContainer />
      </Page>
      <Responsive phone>
        <BreadcrumbsContainer withBackground />
      </Responsive>
    </>
  );
};
